import { useTheme } from '@mui/material'

interface IProps {
  isActive?: boolean
  isSmall?: boolean
}

const ProductsIcon = ({ isActive = false, isSmall = false }: IProps) => {
  const theme = useTheme()
  const fillColor = isActive ? theme.palette.custom.primary : theme.palette.custom.darkBlue2

  return (
    <svg
      width={isSmall ? '16.67' : '20'}
      height={isSmall ? '16.67' : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H7C8.10457 0 9 0.89543 9 2V7C9 8.10457 8.10457 9 7 9H2C0.89543 9 0 8.10457 0 7V2C0 0.89543 0.89543 0 2 0ZM2 11H7C8.10457 11 9 11.8954 9 13V18C9 19.1046 8.10457 20 7 20H2C0.89543 20 0 19.1046 0 18V13C0 11.8954 0.89543 11 2 11ZM16 11H14V14H11V16H14V19H16V16H19V14H16V11ZM2 18V13H7V18H2ZM2 7V2H7V7H2ZM13 0H18C19.1046 0 20 0.89543 20 2V7C20 8.10457 19.1046 9 18 9H13C11.8954 9 11 8.10457 11 7V2C11 0.89543 11.8954 0 13 0ZM13 7V2H18V7H13Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default ProductsIcon
